import React, { useEffect, useState } from "react";
import { EditBlock, EditBlockOption } from "../EditBlock";
import { Button, Col, Radio, Row } from "antd";
import style from "./EditDanXuan.module.scss";
import { QuestionType } from "../../../../../service/service";
import { OptionIsRight, TopicType } from "../../../../../service/homework";
import _ from "underscore";
import { TransInput } from "../TransInput";
import { indexToChar } from "../../../../../utils/common";

interface EditDuoxuanProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange?: (topic: TopicType) => void;
}

export default function EditDanXuan({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditDuoxuanProps) {
    const [innerTopic, setInnerTopic] = useState(topic);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic]);

    const onInputChange = (index: number, value: string) => {
        const newTopic = { ...innerTopic };
        newTopic.answers[index].content = value;
        setInnerTopic(newTopic);
    };

    const onCheckChange = (index: number) => {
        const answers = innerTopic.answers.map((item, itemIndex) => ({
            ...item,
            isRight:
                itemIndex === index ? OptionIsRight.Right : OptionIsRight.Wrong
        }));
        setInnerTopic({ ...innerTopic, answers });
    };

    const getValue = () => {
        return _.findIndex(innerTopic.answers, {
            isRight: OptionIsRight.Right
        });
    };

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    const deleteItem = (index: number) => {
        const newTopic = { ...innerTopic };
        newTopic.answers.splice(index, 1);
        setInnerTopic(newTopic);
    };

    const addItem = () => {
        const newTopic = { ...innerTopic };
        newTopic.answers.push({ content: "", isRight: OptionIsRight.Wrong });
        setInnerTopic(newTopic);
    };

    function renderEditBlock(children: React.ReactNode) {
        return (
            <EditBlock
                {...blockOption}
                type={QuestionType.DanXuan}
                topic={innerTopic}
                onChange={onEditBlockChange}>
                {children}
            </EditBlock>
        );
    }

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.DanXuan}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditDanXuanPure
                blockOption={blockOption}
                innerTopic={innerTopic}
                onCheckChange={onCheckChange}
                onInputChange={onInputChange}
                getValue={getValue}
                addItem={addItem}
                deleteItem={deleteItem}
            />
        </EditBlock>
    );
}

interface EditDanXuanPureProps {
    blockOption?: EditBlockOption;
    innerTopic: TopicType;
    onCheckChange: (index: number) => void;
    onInputChange: (index: number, value: string) => void;
    getValue: () => number;
    addItem: () => void;
    deleteItem: (index: number) => void;
}

export function EditDanXuanPure({
    addItem,
    getValue,
    innerTopic,
    onCheckChange,
    onInputChange,
    deleteItem
}: EditDanXuanPureProps) {
    return (
        <>
            <Col span={2} className={style.label}>
                选项：
            </Col>

            <Col span={20}>
                <Radio.Group
                    onChange={e => onCheckChange(e.target.value)}
                    className={style.RadioGroup}
                    value={getValue()}>
                    {innerTopic.answers.map((option, index) => (
                        <Row
                            gutter={10}
                            type="flex"
                            align="middle"
                            className={style.InputOption}
                            key={index}>
                            <Radio
                                className={style.OptionCheckbox}
                                value={index}>
                                {indexToChar(index)}
                            </Radio>
                            <Col span={22}>
                                <TransInput
                                    index={index}
                                    content={option.content}
                                    onChange={onInputChange}
                                />
                            </Col>
                            <Col span={2}>
                                <Button
                                    onClick={() => deleteItem(index)}
                                    type="danger"
                                    icon="delete"
                                />
                            </Col>
                        </Row>
                    ))}
                    <Button icon={"plus"} onClick={addItem}>
                        增加选项
                    </Button>
                </Radio.Group>
            </Col>
        </>
    );
}
